import React from 'react';
import { SvgIcon } from 'components';

const GrowLevel2 = (props) => (
    <SvgIcon viewBox="0 0 470.6 464.1" {...props}>
      <g>
        <g>
          <path
            fill="#FFFFFF"
            d="M226.5,21.5v-5.2h13.8v-2.9c0-0.9-0.8-1.7-1.7-1.7h-16.7v9.8c0,4.7,3.9,8.6,8.6,8.6h15
			c0.9,0,1.7-0.8,1.7-1.7v-2.9h-16.7C228.3,25.5,226.5,23.7,226.5,21.5z"
          />
          <path
            fill="#FFFFFF"
            d="M238.6,4.8h-15c-0.9,0-1.7,0.8-1.7,1.7v2.9h16.7c2.2,0,4,1.8,4,4v5.2h-13.8v2.9c0,0.9,0.8,1.7,1.7,1.7
			h16.7v-9.8C247.2,8.7,243.4,4.8,238.6,4.8z"
          />
        </g>
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          points="253.6,459.3 255,459.3 243.3,443.6 239.9,448 233,438.7
		217.6,459.3 229,459.3 238,447.3 239.2,449 231.5,459.3 242.9,459.3 244.9,456.6 246.9,459.3 248.4,459.3 245.6,455.6 248.3,452.1
			"
        />
        <g>
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="22.4,234.4 22.4,244.6 27.5,244.6 27.5,239.5
			32.6,239.5 32.6,234.4 		"
          />
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="12.3,239.5 12.3,249.7 22.4,249.7 22.4,244.6
			17.3,244.6 17.3,239.5 		"
          />
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="2.1,234.4 2.1,244.6 7.2,244.6 7.2,239.5 12.3,239.5
			12.3,234.4 		"
          />
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="22.4,224.2 22.4,234.4 12.3,234.4 12.3,229.3
			17.3,229.3 17.3,224.2 		"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M70.1,382.2l13.7-7.9l13.7,7.9v11.9l-4.2,2.4v-2.4l2.1-1.2v-7
		l-4.2,2.4v16.1l-2.1-1.5V394v-4.5l-4.2-2.4v13.4h-2.1v-13.4l-4.2,2.4v3.9v9.5l-2.1,1.5v-16.1l-4.2-2.4v7l2.1,1.2v2.4l-4.2-2.4
		V382.2L70.1,382.2z M95.3,383.4l-11.6-6.7l-11.6,6.7l6.3,3.6l5.3-3l5.3,3L95.3,383.4z"
        />
        <g>
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="90.8,87 79,75.2 83,68.2 94.8,80 		"
          />
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="68.3,75.4 72.3,68.5 79,75.2 		"
          />
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="86.8,93.9 80.1,87.2 90.8,87 		"
          />
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            points="76.1,94.1 64.3,82.3 68.3,75.4 80.1,87.2 		"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M398.9,377.3l-1.1,1.9h-15.4l-8.8,15.3h2.2l7.7-13.3h17.6
		l-1.1,1.9h-15.4l-6.6,11.4h2.2l5.4-9.4h17.6l-11.1,19.2h-17.6l1.1-1.9h15.4L400,387h-2.2l-7.7,13.3h-17.6l1.1-1.9h15.4l6.6-11.4
		h-2.2l-5.4,9.4h-17.6l11.1-19.2H398.9L398.9,377.3z M391,387h-4.1l-4.3,7.5h4.1L391,387z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M395.6,89.1c1.1,0.5,2.3,0.8,3.6,0.8c4.5,0,8.1-3.6,8.1-8.1
		c0-4.5-3.6-8.1-8.1-8.1c-1.2,0-2.3,0.3-3.4,0.7c-1-0.5-2.2-0.7-3.4-0.7c-1.3,0-2.5,0.3-3.6,0.8c-1.1-0.5-2.3-0.8-3.6-0.8
		c-4.5,0-8.1,3.6-8.1,8.1c0,4.5,3.6,8.1,8.1,8.1c1.2,0,2.3-0.3,3.4-0.7c1,0.5,2.2,0.7,3.4,0.7C393.4,89.9,394.6,89.6,395.6,89.1
		L395.6,89.1z M393.4,87.5c-0.4,0.1-0.9,0.2-1.4,0.2c-3.2,0-5.8-2.6-5.8-5.8c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1
		c0,2.2,0.9,4.3,2.4,5.7c-0.3,0.1-0.7,0.1-1,0.1c-3.2,0-5.8-2.6-5.8-5.8c0-3.2,2.6-5.8,5.8-5.8c3.2,0,5.8,2.6,5.8,5.8
		C391.2,84,392,86.1,393.4,87.5L393.4,87.5z M399.4,83c0.6,0,1.1-0.5,1.1-1.1c0-2.2-0.9-4.3-2.4-5.7c0.3-0.1,0.7-0.1,1-0.1
		c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.6,5.8-5.8,5.8c-3.2,0-5.8-2.6-5.8-5.8c0-2.2-0.9-4.2-2.3-5.6c0.4-0.1,0.9-0.2,1.4-0.2
		c3.2,0,5.8,2.6,5.8,5.8C398.3,82.5,398.8,83,399.4,83z"
        />
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            d="M451,240.2c13.5-9.2,10.2,0.4,17.6,2.4c-3.5,4-10.1,3-12.6-2.1
			c0.3,1.8,1.1,3.3,2.2,4.5c-8.7,5.4-12.3,2.4-16.2-2.1C445.3,243.7,448.3,242.1,451,240.2z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            d="M454.9,235.9c-13.5,9.2-10.2-0.4-17.6-2.4c3.5-4,10.1-3,12.6,2.1
			c-0.3-1.8-1.1-3.3-2.2-4.5c8.7-5.4,12.3-2.4,16.2,2.1C460.6,232.5,457.7,234.1,454.9,235.9z"
          />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M270.1,448.2c0.1,0.5,0.1,1,0.1,1.5c33.3-5.4,64.1-18.4,90.5-37.1c-0.3-0.4-0.7-0.8-1-1.2
			C333.6,429.9,303.1,442.8,270.1,448.2z"
          />
          <path
            fill="#FFFFFF"
            d="M57,109.7c-0.4-0.3-0.8-0.6-1.2-1c-19.2,27.4-32.3,59.3-37.3,93.8c0.5,0,1,0,1.5,0
			C25,168.5,38,136.8,57,109.7z"
          />
          <path
            fill="#FFFFFF"
            d="M110.2,411.6c-0.3,0.4-0.7,0.8-1,1.2c26.8,18.9,58,31.9,91.7,37.2c0-0.5,0.1-1,0.1-1.5
			C167.6,443.2,136.7,430.3,110.2,411.6z"
          />
          <path
            fill="#FFFFFF"
            d="M409.2,363.1c0.4,0.3,0.8,0.7,1.2,1c19.7-26.6,33.6-57.8,39.7-91.6c-0.5,0-1-0.1-1.5-0.1
			C442.5,305.9,428.8,336.8,409.2,363.1z"
          />
          <path
            fill="#FFFFFF"
            d="M201.2,19.6c-0.1-0.5-0.1-1-0.2-1.5c-35.9,5.6-69,20-96.9,40.9c0.3,0.4,0.7,0.8,1,1.1
			C132.8,39.4,165.6,25.2,201.2,19.6z"
          />
          <path
            fill="#FFFFFF"
            d="M21.1,271.9c-0.5,0-1,0.1-1.5,0.1c6,34.1,20,65.6,39.9,92.3c0.4-0.4,0.7-0.7,1.1-1
			C40.9,336.8,27.1,305.7,21.1,271.9z"
          />
          <path
            fill="#FFFFFF"
            d="M449.7,203.3c0.5,0,1-0.1,1.5-0.1c-5-35.1-18.3-67.5-37.9-95.2c-0.4,0.3-0.8,0.7-1.2,1
			C431.6,136.4,444.7,168.5,449.7,203.3z"
          />
          <path
            fill="#FFFFFF"
            d="M363.8,59.6c0.3-0.4,0.7-0.8,1-1.1c-27.4-20.3-59.6-34.4-94.7-40.1c-0.1,0.5-0.1,1-0.2,1.5
			C304.7,25.5,336.7,39.5,363.8,59.6z"
          />
        </g>
      </g>
    </SvgIcon>
  )

export default GrowLevel2;
